import { Component } from '@angular/core';

@Component({
    selector: 'atlas-style-guide-workspace',
    templateUrl: './style-guide-workspace.component.html',
    styleUrls: ['./style-guide-workspace.component.less'],
    standalone: false
})
export class StyleGuideWorkspaceComponent {}
